import {API_DRIVER} from "../config/axios";
import {TicketStatus} from "../component/client-panel/vouchers/vouchers-filter/VouchersFilterHelper";

export enum PaymentStatus {
    PENDING = "PENDING",
    COMPLETED = "COMPLETED",
    CANCELED = "CANCELED",
}

export interface ITicketCreate {
    wish_id: string
    ticket_count: number
    recipient_email?: string
    recipient_name?: string
    personal_message?: string
}

export interface IFreeVoucherCreate {
    wish_id: string
}

export interface IUnreserveVouchers {
    order_id: string
}

export interface IAdminTicketUser {
    id: string
    full_name: string
    email: string
    city: string | null
    address: string | null
    phone_number: string | null
}

export interface IAdminTicketWish {
    id: string
    name_en: string
    name_mk: string
    name_al: string
    type: string
}

export interface IAdminTicket {
    id: string
    code: string | null
    order_id: string
    payment_status: PaymentStatus
    cost: number
    points: number | null
    used_points: number
    created_at: string
    user: IAdminTicketUser
    wish: IAdminTicketWish
}

export interface IAdminTicketsResponse {
    total_pages: number
    count: number
    data: IAdminTicket[]
}

export interface IAdminTicketFilters {
    searchText?: string
    wishType?: string
    paymentStatus?: PaymentStatus | ""
    startDate?: string
    endDate?: string
}

const getTicketsRequestUrl = (endpointUrl: string) => {
    return `/api/tickets${endpointUrl}`
}

const TicketService = {
    obtainEntries: (body: ITicketCreate) => {
        return API_DRIVER.post(getTicketsRequestUrl(`/obtain-entries`), body)
    },
    obtainFreeVoucher: (body: IFreeVoucherCreate) => {
        return API_DRIVER.post(getTicketsRequestUrl(`/obtain-free-voucher`), body)
    },
    unreserveVouchers: (body: IUnreserveVouchers) => {
        return API_DRIVER.put(getTicketsRequestUrl(`/unreserve`), body)
    },
    fetchTicketsForUser: (wishId: string) => {
        return API_DRIVER.get(getTicketsRequestUrl(`/wish/${wishId}`))
    },
    fetchTicketsForWish: (wishId: string) => {
        return API_DRIVER.get(getTicketsRequestUrl(`/wish/${wishId}/random`))
    },
    fetchAdminTickets: (page: number, size: number, filters?: IAdminTicketFilters) => {
        return API_DRIVER.get<IAdminTicketsResponse>(getTicketsRequestUrl("/admin"), {
            params: {
                limit: size,
                offset: page,
                search_text: filters?.searchText?.trim() || undefined,
                wish_type: filters?.wishType?.trim() || undefined,
                payment_status: filters?.paymentStatus || undefined,
                start_date: filters?.startDate || undefined,
                end_date: filters?.endDate || undefined,
            }
        })
    },
    fetchClientWishTickets: (wishId: string, params: {
        limit: number
        offset: number
        search_text?: string
        status?: TicketStatus
    }) => {
        return API_DRIVER.get(getTicketsRequestUrl(`/wish/${wishId}/client`), {
            params
        })
    },
}

export default TicketService
